function getCoeditedTenantUserSkills (
  tenantUserId,
  tenantUserSkills,
  sort = true,
) {
  return tenantUserSkills
    .filter(elem => !elem.isApproved)
    .filter(elem => {
      return (
        elem.creater === undefined ||
        elem.creater === null ||
        elem.tenantUser.id !== elem.creater?.id
      );
    })
    .sort((a, b) => {
      if (!sort) {
        return 1;
      }

      let priority = a.isApproved ? 1 : -1;

      priority -= (
        tenantUserId === a.creater?.id &&
        tenantUserId !== b.creater?.id) * 1;
      priority -= (
        tenantUserId === a.creater?.id &&
        tenantUserId === b.creater?.id) * 1;
      priority += (
        tenantUserId !== a.creater?.id &&
        tenantUserId === b.creater?.id) * 1;

      return priority;
    });
}

function getTenantUserSkillEdges (tenantUserSkills, neighborsKeyName='targets') {
  const tenantUserSkillIds = tenantUserSkills.map(elem => elem.id);

  return [...new Set(
    tenantUserSkills.reduce((parent, elem) => {
      const edges = elem[neighborsKeyName].reduce((child, tenantUserSkillId) => {
        if (!tenantUserSkillIds.includes(tenantUserSkillId) ||
            !tenantUserSkillIds.includes(elem.id)) {
          return child;
        }
        const pair1 = { source: elem.id, target: tenantUserSkillId };
        const pair2 = { source: tenantUserSkillId, target: elem.id };
        child.push(JSON.stringify(pair1, Object.keys(pair1).sort()));
        child.push(JSON.stringify(pair2, Object.keys(pair2).sort()));
        return child;
      }, []);
      parent.push(...edges);
      return parent;
    }, []))].map(elem => JSON.parse(elem));
}

const skillNodeRadiusFunctions = {
  byPeriod: (node, defaultRadius, radius, monthsThresh = 24) => {
    const period = node.experiencePeriodCategory;
    if(period == null) {
      return defaultRadius;
    }
    return period.months > monthsThresh ? radius : defaultRadius;
  },
};

export {
  getCoeditedTenantUserSkills,
  getTenantUserSkillEdges,
  skillNodeRadiusFunctions,
};
